import { initExpLoader } from '@js-packages/experiment-loader';
import experiments from './configExtra.json';

initExpLoader({
  config: experiments,
  geoUrl: '/get_country_code',
  experimentInits: {
    tzPlatformLinks: () =>
      import(
        /* webpackChunkName: "tzPlatformLinks.chunk" */
        './tzPlatformLinks/js/main.js'
      ),
    propclick: () =>
      import(
        /* webpackChunkName: "propclick.chunk" */
        './propclick/js/main.js'
      ),
    tzLandingFree: () =>
      import(
        /* webpackChunkName: "tzLandingFree.chunk" */
        './tzLandingFree/js/main.js'
      ),
  },
});
